<template>
  <div id="app">
    <div class="Popover">
      <div :class="{'active':popActive==0}" class="Popoverbox" @click="changepop(0)">
        <img src="../../static/img/dnx-88.png" class="Popover-img" v-if="popActive!==0" />
        <img src="../../static/img/dnxh-88.png" class="Popover-img" v-if="popActive==0" />
        <div class="Popover-tit">所有案例</div>
      </div>
      <div :class="{'active':popActive==1}" class="Popoverbox" @click="changepop(1)">
        <img src="../../static/img/dnx-89.png" class="Popover-img" v-if="popActive!==1" />
        <img src="../../static/img/dnxh-89.png" class="Popover-img" v-if="popActive==1" />
        <div class="Popover-tit">按解决方法</div>
        <div class="sanjiao" v-if="isActive==1"></div>
      </div>
      <div :class="{'active':popActive==2}" class="Popoverbox" @click="changepop(2)">
        <img src="../../static/img/dnxh-90.png" class="Popover-img" v-if="popActive==2"/>
        <img src="../../static/img/dnx-90.png" class="Popover-img" v-if="popActive!==2"/>
        <div class="Popover-tit">按行业领域</div>
        <div class="sanjiao" v-if="isActive==2"></div>
      </div>
    </div>
    <div class="menutype" v-if="isActive!=0">
      <div v-if="isActive ==2" class="menubox">
        <div v-for="(item,index) in menutype" :key="index" class="menu-item" @click="getInfo(item.business)">
          <img :src="item.imgPath" class="icon" />
          <div>{{item.business}}</div>
        </div>
      </div>
      <div v-if="isActive ==1" class="menubox">
        <div v-for="(item,index) in menutype" :key="index" class="menu-item" @click="getInfo(item.plateName)">
          <img :src="item.imgPath" class="icon" />
          <div>{{item.plateName}}</div>
        </div>
      </div>
    </div>
    <div class="container" v-if="isActive==0">
      <el-row>
        <div v-for="(item,index) in List" :key="index">
          <el-col :xs="12" :sm="8" :md="8" :lg="8" :xl="8" class="scale-in d1" id="scale-in">
            <div class="box-card">
              <!-- <img src="../../static/img/dn-60.png" @click="$router.push('Business/MortgageLoan');" /> -->
              <div class="imgbox">
                <img :src="item.cover" class="card-img" id="box-card" :style="{ height: cardheight*0.83 + 'px' }" />
                <div class="overlay-box" :style="{ height: cardheight*0.83 + 'px' }" @click="CaseDetail(item.id)">
                  <div>{{item.title}}</div>
                  <div class="two Light">{{item.plates}}</div>
                </div>
              </div>
              <div class="m">{{item.title}}</div>
              <div class="sm Light">{{item.plates}}</div>
            </div>
          </el-col>
          <div class="clearfix visible-xs pc" v-if="(index+1) % 3 == 0 && index!==1"></div>
          <div class="clearfix visible-xs phone" v-if="(index+1) % 2 == 0 && index!==1"></div>
        </div>
      </el-row>
    </div>
    <div class="container" v-if="isActive==1">
      <el-row>
        <div v-for="(item,index) in List" :key="index">
          <el-col :xs="12" :sm="8" :md="8" :lg="8" :xl="8" class="scale-in d1" id="scale-in">
            <div class="box-card">
              <!-- <img src="../../static/img/dn-60.png" @click="$router.push('Business/MortgageLoan');" /> -->
              <div class="imgbox">
                <img :src="item.cover" class="card-img" id="box-card" :style="{ height: cardheight*0.83 + 'px' }" />
                <div class="overlay-box" :style="{ height: cardheight*0.83 + 'px' }" @click="CaseDetail(item.id)">
                  <div>{{item.title}}</div>
                  <div class="two Light">{{item.plates}}</div>
                </div>
              </div>
              <div class="m">{{item.title}}</div>
              <div class="sm Light">{{item.plates}}</div>
            </div>
          </el-col>
          <div class="clearfix visible-xs pc" v-if="(index+1) % 3 == 0 && index!==1"></div>
          <div class="clearfix visible-xs phone" v-if="(index+1) % 2 == 0 && index!==1"></div>
        </div>
      </el-row>
    </div>
    <div class="container" v-if="isActive==2">
      <el-row>
        <div v-for="(item,index) in List" :key="index">
          <el-col :xs="12" :sm="8" :md="8" :lg="8" :xl="8" class="scale-in d1" id="scale-in">
            <div class="box-card">
              <div class="imgbox">
                <img :src="item.cover" class="card-img" id="box-card" :style="{ height: cardheight*0.83 + 'px' }" />
                <div class="overlay-box" :style="{ height: cardheight*0.83 + 'px' }" @click="CaseDetail(item.id)">
                  <div>{{item.title}}</div>
                  <div class="two Light">{{item.business}}</div>
                </div>
              </div>
              <div class="m">{{item.title}}</div>
              <div class="sm Light">{{item.business}}</div>
            </div>
          </el-col>
          <div class="clearfix visible-xs pc" v-if="(index+1) % 3 == 0 && index!==1"></div>
          <div class="clearfix visible-xs phone" v-if="(index+1) % 2 == 0 && index!==1"></div>
        </div>
      </el-row>
    </div>
    <Call></Call>
  </div>
</template>

<script>
  import Call from "../components/CallUs";
  import Swiper from 'swiper';
  export default {
    components: {
      Call
    },
    data() {
      return {
        popActive:0,
        pageCount:1,
        currentPage:1,
        isActive:0,
        menutype: [],
        List:[{
          cover:'../../static/img/dn-60.png'
        }],
        cardheight:0
      }
    },
    mounted: function () {
      this.Init()
    },
    watch:{   //监听路由变化
      $route( to , from ){   
        this.Init()
      }
    },
    deactivated() {
      this.$destroy()
    },
    methods: {
      Init(){
        this.getInfo()
        this.cardheight = document.querySelector('#scale-in').offsetWidth
        window.addEventListener('resize', () => 
          this.cardheight = document.querySelector('#scale-in').offsetWidth
        )
      },
      CaseDetail(id,type){
        if(this.isActive == 0 ){
          sessionStorage.setItem('business', '');
          sessionStorage.setItem('plate', '');
        }else if(this.isActive == 1){
          sessionStorage.setItem('business', '');
          sessionStorage.setItem('plate', type);
        }else{
          sessionStorage.setItem('business', type);
          sessionStorage.setItem('plate', '');
        }
        // this.$router.push("/Case/id=" + id);
        let routeData = this.$router.resolve({
          path: "/Case/id=" + id,
        });
        window.open(routeData.href, '_blank');
      },
      changepop(i){
        this.isActive = i
        this.popActive = i
        if(i == 1){
          this.url = "deno/api/plate/list"
          this.gettype()
        }else if(i ==2){
          this.url = "deno/api/business/list"
          this.gettype()
        }else{
          this.getInfo()
        }
      },
      gettype(){
        this.$http
          .get(this.url, {
          })
          .then(
            function (response) {
              var status = response.data.code;
              if (status === 0) {
                this.menutype = response.data.page.list;
              }
            }.bind(this)
          )
      },
      getInfo(menutype) {
        let plate = ''
        let business = ''
        let title = ''
        if(sessionStorage.getItem('input')!=='null'){
          title = sessionStorage.getItem('input')
        }else{
          if(this.isActive == 1){
            plate = menutype
          }else{
            business = menutype
          }
        }
       
        this.$http
          .get("deno/api/case/list", {
            params: {
              page:1,
              limit: 999,
              plate:plate,
              business:business,
              title:title
            }
          })
          .then(
            function (response) {
              var status = response.data.code;
              if (status === 0) {
                this.List = response.data.page.list;
                for (let i = 0; i < this.List.length; i++) {
                  this.List[i].plates = this.List[i].plates.replaceAll(',',' / ')
                  this.List[i].business = this.List[i].business.replaceAll(',',' / ')
                }
                sessionStorage.setItem('input', 'null');
              }
            }.bind(this)
          )
      },
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
.Popover
  display: flex;
  justify-content: center;
  margin: 30px;
  padding: 10px 0;
  color: #fff;
  background-color: #333;
  .Popoverbox
    margin: 0 20px;
    display: flex;
    align-items: center;
    font-size: 20px;
    position relative
    .sanjiao 
      width: 0;
      height: 0;
      border-right: 5px solid transparent;
      border-left: 5px solid transparent;
      border-top: 5px solid #333;
      position: absolute;
      bottom: -15px;
      right: 45%;
    .Popover-img
      width 20px
      margin-right: 10px;
    .Popover-tit
      cursor pointer
  .Popoverbox.active
    color #ffda2a
.box-card:hover .overlay-box .Light
  margin-top 42px
.menubox
  display: flex;
.menutype
  display: flex;
  font-size: 16px;
  margin-top: -30px;
  justify-content: center;
  .menu-item
    padding 20px 30px;
    text-align center
    border-radius: 10px;
    margin: 10px;
    .icon
      margin-bottom: 10px;
      width 50px;
      height 50px;
  .menu-item:hover
    -webkit-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
    cursor pointer
@media screen and (max-width:768px)
  .Popover
    margin 5px
  .Popover .Popoverbox
    font-size: 14px;
  .product
    margin: 60px 0 0 0;
  .dbanner .banner-title .title
    line-height: 70px;
    font-size: 20px;
  .typebox
    margin: 60px 0 0 0;
  .smalltitle
    font-size 22px
  .home-banner,.dark
    padding 0 5px
  .menutype
    margin-top 0
  .menubox
    display flex
    flex-wrap: wrap;
    .menu-item
      width: 33.3%;
      padding: 10px 0;
      margin 0
      .icon
        width 30px
        height 30px
.container
  padding-bottom 30px
.card-img
  width: 100%;
  height: 100%
  cursor: pointer;
.box-card
  font-size 16px
  .m
    margin-top 20px
  .sm
    font-size 14px
    margin: 20px 0 60px 0;
.imgbox
  padding: 0
  position relative
  cursor pointer
  .m
    margin-top 32px
.imgbox:hover 
  opacity: 0.9;
  overflow hidden
  color: #fff;
.imgbox .overlay-box
  display none
.imgbox:hover .overlay-box
  flex-direction: column;
  cursor pointer
  bottom 0
  top 0
  background: rgba(255, 255, 255, 1);
  display block
  position: absolute;
  font-size: 16px;
  left: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  color: #000;
@media (min-width:1920px) 
  .Popover
    padding: 30px 0;
    margin 30px 60px
  .Popover .Popoverbox
    font-size: 24px;
  .Popover .Popoverbox .Popover-img
    width 35px
  .box-card:hover .overlay-box
    font-size 26px
  .box-card:hover .overlay-box .two
    color #333
    margin-top 52px
    font-size 20px
  .box-card
    font-size: 20px;
  .box-card .m
    margin-top 20px
  .box-card .sm
    font-size: 18px;
    margin-bottom 60px
  .menutype .menu-item
    padding: 20px 60px;
    font-size 20px
  .menutype .menu-item .icon
    width 64px
    height 64px
  .Popover .Popoverbox .sanjiao
    border-right: 15px solid transparent;
    border-left: 15px solid transparent;
    border-top: 15px solid #333333;
    bottom: -45px;
    right 36%
</style>


// WEBPACK FOOTER //
// src/components/Case.vue